import * as queries from "./query";
import RootService from "@services";

export default new RootService({ queries });
